import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 导入 Element UI 和全部的样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "./plugins/EUtils"
import Katex from 'vue-katex-auto-render'
Vue.directive('katex', Katex);
import "katex/dist/contrib/mhchem"
Vue.prototype.dataurl = 'https://m.shangkao.com.cn';
Vue.prototype.osUrl = 'https://skos.shangkao.com.cn/';
// Vue.prototype.dataurl = '/lpl';
// Vue.prototype.osUrl = '/lplos/';
import store from './store'
// 使用 Element UI
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
